import { useState, useEffect } from "react"

const useIsTouchDevice = (): boolean => {
  const [isTouchDevice, setIsTouchDevice] = useState(false)

  useEffect(() => {
    const checkTouchSupport = () => {
      if (typeof window === "undefined") return false

      return (
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        // @ts-ignore
        navigator.msMaxTouchPoints > 0
      )
    }

    setIsTouchDevice(checkTouchSupport())
  }, [])

  return isTouchDevice
}

export default useIsTouchDevice
